import { useState, useCallback } from 'react';
import { apiClient } from '../api/client';

export interface Group {
  id: string;
  org_id: string;
  name: string;
  description: string;
  created_at: string;
  members_count?: number;
  credentials_count?: number;
  member_ids?: string[];
  credential_ids?: string[];
}

export function useGroups() {
  const [groups, setGroups] = useState<Group[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchGroups = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await apiClient.get<Group[]>('/groups');
      setGroups(data);
      setError(null);
    } catch (err: any) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const createGroup = async (payload: { name: string; description: string }) => {
    await apiClient.post('/groups', payload);
    await fetchGroups();
  };

  const associateCredentials = async (groupId: string, credentialIds: string[]) => {
    await apiClient.put(`/groups/${groupId}/credentials`, { credential_ids: credentialIds });
    await fetchGroups();
  };

  const associateMembers = async (groupId: string, memberIds: string[]) => {
    await apiClient.put(`/groups/${groupId}/members`, { user_ids: memberIds });
    await fetchGroups();
  };

  return {
    groups,
    isLoading,
    error,
    fetchGroups,
    createGroup,
    associateCredentials,
    associateMembers,
  };
}
